import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Consulta } from 'src/app/models/consulta';
import { ConsultaComposta } from 'src/app/models/consulta-composta';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConsultaService {

  constructor(private httpClient: HttpClient) { }

  listaConsultaAvulsaCombinada() {
    return this.httpClient.get<any[]>(environment.wsUrl + 'consulta/listaAvulsaCombinada').toPromise();
  }
  listaConsulta() {
    return this.httpClient.get<Consulta[]>(environment.wsUrl + 'consulta/listaPermissao').pipe(
      map(r => r.map(c => new Consulta(c)))
    ).toPromise();
  }

  listaConsultaExperimental() {
    return this.httpClient.get<Consulta[]>(environment.wsUrl + 'consulta/listaConsultaExperimental').pipe(
      map(r => r.map(c => new Consulta(c)))
    ).toPromise();
  }

  listaConsultaComposta() {
    return this.httpClient.get<ConsultaComposta[]>(environment.wsUrl + 'consulta/listaConsultaComposta').pipe(
      map(r => r.map(c => new ConsultaComposta(c)))
    ).toPromise();
  }

  listaConsultaCompostaUnidade(id, ignore = []) {
    return this.httpClient.get<ConsultaComposta[]>(environment.wsUrl + 'consulta/listaConsultaCompostaUnidade/' + id, {
      params: {
        ignore: ignore
      },
    }).pipe(
      map(r => r.map(c => new ConsultaComposta(c)))
    ).toPromise();
  }

  getComposta(uuid) {
    return this.httpClient.get<ConsultaComposta>(environment.wsUrl + 'consulta/getConsultaComposta/' + uuid).pipe(
      map(c => new ConsultaComposta(c))
    ).toPromise();
  }

  listaConsultaCombinada() {
    return this.httpClient.get<ConsultaComposta[]>(environment.wsUrl + 'consulta/listaConsultaCombinadaEditar').pipe(
      map(r => r.map(c => new ConsultaComposta(c)))
    ).toPromise();
  }

  listaConsultaEspecial() {
    return this.httpClient.get<Consulta[]>(environment.wsUrl + 'consulta/listaConsultaEspecial').pipe(map(r => r.map(c => new Consulta(c)))).toPromise();
  }

  listaConsultaDecisaoCerta() {
    return this.httpClient.get<Consulta[]>(environment.wsUrl + 'consulta/listaConsultaCombinadaEditar').pipe(map(r => r.map(c => new Consulta(c)))).toPromise();
  }

  adicionarComposta(data, justificativa) {
    return this.httpClient.post(environment.wsUrl + 'consulta/criarConsultaComposta', data, {
      headers: { justificativa: justificativa },
    }).toPromise();
  }

  adicionarCompostaUnidade(data, justificativa, ignore = []) {
    return this.httpClient.post(environment.wsUrl + 'consulta/criarConsultaCompostaUnidade', data, {
      headers: { justificativa: justificativa, ignore: ignore },
    }).toPromise();
  }

  editarComposta(data, justificativa) {
    return this.httpClient.post(environment.wsUrl + 'consulta/atualizarConsultaComposta', data, {
      headers: { justificativa: justificativa },
    }).toPromise();
  }

  excluirComposta(data, justificativa) {
    return this.httpClient.post(environment.wsUrl + 'consulta/deletarComposta', data, {
      headers: { justificativa: justificativa },
    }).toPromise();
  }

  adicionarCombinada(data, justificativa) {
    return this.httpClient.post(environment.wsUrl + 'consulta/criarConsultaCombinada', data, {
      headers: { justificativa: justificativa },
    }).toPromise();
  }

  listarConsultaUsuario() {
    return this.httpClient.get<Consulta[]>(environment.wsUrl + 'consulta/listaConsultasPorUsuarioLogado', {
      headers: {},
    }).pipe(map(r => r.map(c => new Consulta(c)))).toPromise();
  }

  getRelatorioPdf(url: string) {
    const fullUrl = `${environment.wsUrl}relatorio/relatorioPdf/${url}`;
    return this.httpClient.get(fullUrl, { responseType: 'blob' });
  }

}
